import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { CustomTheme } from './custom-theme/CustomTheme';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { HTML_THEME } from 'drapcode-constant';

export class CustomThemeTab extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
    actions.loadCustomHtmlFiles({ projectId, version });
  }

  render() {
    const { appSetting, actions, match } = this.props;
    const { projectDetail, permissionFlags } = appSetting;
    if (!projectDetail) {
      return '';
    }
    const { customThemeFiles, customHtmlCdns, customHtmlFiles } = projectDetail;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'customTheme'} projectDetail={projectDetail} />
        <CustomTheme
          customThemeFiles={customThemeFiles}
          customHtmlCdns={customHtmlCdns}
          customHtmlFiles={customHtmlFiles}
          loadCustomThemeFiles={actions.loadCustomThemeFiles}
          loadCustomHtmlFiles={actions.loadCustomHtmlFiles}
          deleteCustomThemeFile={actions.deleteCustomThemeFile}
          deleteFlag={permissionsArray.includes(HTML_THEME)}
        />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomThemeTab);
